// import  { useEffect, useState } from "react";
// import { useHistory, useLocation, useParams } from "react-router-dom";
// import { Search } from "@mui/icons-material";
// import { IoFilter } from "react-icons/io5";
// import { IoIosArrowBack } from "react-icons/io";

// const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;
// const GET_IMAGES_API = `${BASE_URL}/ocr/getimages/`;

// const PackageView = () => {
//   const { packageName } = useParams();
//   const [open, setOpen] = useState(false);
//   const location = useLocation();
//   const { files } = location.state || {};
//   const [query, setQuery] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [activeTab, setActiveTab] = useState("Drawings");
//   const history = useHistory();
//   const [drawings, setDrawings] = useState([]);


//   const statusColors = {
//     "AI Processing started & Validation pending": "bg-red-400",
//     Completed: "bg-green-400",
//   };
//   const handlebackFolder = () => {
//     history.push("/createfolder");
//   }

//   const handleBack = () => {
//     setSelectedImage(null);
//     setActiveTab("Drawings");
//   };

//   useEffect(() => {
//     setDrawings(files);
//   }, []);

//   return (
//     <div className="p-6">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6">
//         <div className="flex items-center gap-4">
//           <button className="text-xl font-bold"
//           //  onClick={handlebackFolder}
//           >
//             <IoIosArrowBack />
//           </button>
//           <h2 className="text-2xl  font-semibold ">Drawings</h2></div>
//         {!selectedImage && (
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center border border-gray-300 rounded px-2 bg-white">
//               <Search className="text-gray-500" fontSize="small" />
//               <input
//                 type="text"
//                 placeholder="Search"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 className="p-1 outline-none text-sm"
//               />
//             </div>

//             <button
//               className="flex gap-2 bg-[#FECF8B] text-black font-medium px-4 py-2 rounded"
//               onClick={() => setOpen(true)}
//             >
//               <IoFilter fontSize={25} /> Filter
//             </button>
//           </div>
//         )}
//       </div>
//       <div className="h-px bg-gray-700 w-full"></div>

//       <h2 className="text-xl font-semibold my-4">{packageName}</h2>
//       {selectedImage ? (
//         <div>
//           <button
//             onClick={handleBack}
//             className="mb-4 bg-gray-200 hover:bg-orange-300 text-gray-700 px-4 py-2 rounded"
//           >
//             ← Back
//           </button>

         
//         </div>
//       ) : (
//         <>
//           {/* Legend */}
//           <div className="flex flex-wrap justify-around mb-6">
//             {Object.entries(statusColors).map(([key, color]) => (
//               <div key={key} className="flex items-center gap-2">
//                 <span className={`w-6 h-6 rounded-full ${color}`}></span>
//                 <span className="text-sm capitalize">{key}</span>
//               </div>
//             ))}
//           </div>

//           {/* Grid */}
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6  ">
//             {drawings.length > 0 ? (
//               drawings.map((file, i) => (
//                 <div
//                   key={i}
//                   className=" relative bg-white p-2 sm:p-4 lg:p-6   rounded-lg flex flex-col items-center shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out shadow-gray-600" >
//                   <img
//                     src={file.image_sets.Drawing[0]}
//                     alt={file.filename}
//                     className="   object-contain rounded border border-red"
//                   />

//                   <div className="flex space-between center">
//                     <span className="left-2 text-sm font-semibold text-gray-700">
//                       {file.filename}
//                     </span>
//                     <span
//                       className={`sm:w-5  sm:h-3 lg:w-3 lg:h-3 m-1 rounded-full 
//     ${file.status_value == 100
//                           ? "bg-green-500"
//                           : file.status_value == 75
//                             ? "bg-red-500"
//                             : file.status_value == 15
//                               ? "bg-red-500"
//                               : "bg-black"
//                         }`}
//                     ></span>
//                   </div>

//                   {/* Open button */}
//                   <button
//                     className="mt-2 w-full h-10 bg-transparent hover:bg-[#0e4749] text-black font-semibold text-md px-3 py-1 rounded border border-black hover:text-white transition"
//                     onClick={() =>
//                       history.push({
//                         pathname: "/drawingdetailview/:packageName/:imageName",
//                         state: {
//                           files: files,
//                         },
//                       })
//                     }
//                   >
//                     Open
//                   </button>
//                 </div>
//               ))
//             ) : (
//               <div className="flex justify-center items-center text-center  w-full h-full">
//                 No Data Available
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default PackageView;


import { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Search } from "@mui/icons-material";
import { IoFilter } from "react-icons/io5";
import { IoIosArrowBack } from "react-icons/io";

const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;
const GET_IMAGES_API = `${BASE_URL}/ocr/getimages/`;

const PackageView = () => {
  const { packageName } = useParams();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { files } = location.state || {};
  const [query, setQuery] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState("Drawings");
  const history = useHistory();
  const [drawings, setDrawings] = useState([]);

  const statusColors = {
    "AI Processing started & Validation pending": "bg-red-400",
    Completed: "bg-green-400",
  };

  const handleBackFolder = () => {
    history.push("/createfolder");
  };

  const handleBack = () => {
    setSelectedImage(null);
    setActiveTab("Drawings");
  };

  useEffect(() => {
    setDrawings(files || []);
  }, [files]);

  // Filter by search query
  const filteredDrawings = drawings.filter((file) =>
    file.filename?.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6">
        <div className="flex items-center gap-4">
          <button className="text-xl font-bold" onClick={handleBackFolder}>
            <IoIosArrowBack />
          </button>
          <h2 className="text-2xl font-semibold">Drawings</h2>
        </div>

        {!selectedImage && (
          <div className="flex items-center space-x-4">
            <div className="flex items-center border border-gray-300 rounded px-2 bg-white">
              <Search className="text-gray-500" fontSize="small" />
              <input
                type="text"
                placeholder="Search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="p-1 outline-none text-sm"
              />
            </div>

            <button
              className="flex gap-2 bg-[#FECF8B] text-black font-medium px-4 py-2 rounded"
              onClick={() => setOpen(true)}
            >
              <IoFilter fontSize={25} /> Filter
            </button>
          </div>
        )}
      </div>

      <div className="h-px bg-gray-700 w-full"></div>

      <h2 className="text-xl font-semibold my-4">{packageName}</h2>

      {/* Image Preview Modal */}
      {selectedImage ? (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex flex-col items-center justify-center z-50">
          <button
            onClick={handleBack}
            className="absolute top-6 right-6 bg-white px-4 py-2 rounded shadow-lg hover:bg-gray-200"
          >
            ✕ Close
          </button>
          <img
            src={selectedImage}
            alt="Selected Drawing"
            className="max-h-[85vh] rounded shadow-xl"
          />
        </div>
      ) : (
        <>
          {/* Legend */}
          <div className="flex flex-wrap justify-around mb-6">
            {Object.entries(statusColors).map(([key, color]) => (
              <div key={key} className="flex items-center gap-2">
                <span className={`w-6 h-6 rounded-full ${color}`}></span>
                <span className="text-sm capitalize">{key}</span>
              </div>
            ))}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
            {filteredDrawings.length > 0 ? (
              filteredDrawings.map((file, i) => (
                <div
                  key={i}
                  className="relative bg-white p-4 rounded-lg flex flex-col items-center shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out shadow-gray-600"
                >
                  <div className="flex flex-col gap-3 w-full items-center">
                    {file.image_sets?.Drawing?.length > 0 ? (
                      file.image_sets.Drawing.map((imgUrl, index) => (
                        <img
                          key={index}
                          src={imgUrl}
                          alt={`${file.filename}-drawing-${index + 1}`}
                          className="w-full h-40 object-contain rounded border cursor-pointer hover:opacity-80 transition"
                          onClick={() => setSelectedImage(imgUrl)}
                        />
                      ))
                    ) : (
                      <p className="text-gray-400 text-sm">
                        No drawings found
                      </p>
                    )}
                  </div>

                  {/* Filename + Status */}
                  <div className="flex justify-between items-center mt-2 w-full">
                    <span className="text-sm font-semibold text-gray-700 truncate">
                      {file.filename}
                    </span>
                    <span
                      className={`w-3 h-3 rounded-full ${
                        file.status_value == 100
                          ? "bg-green-500"
                          : file.status_value == 75
                          ? "bg-red-500"
                          : file.status_value == 15
                          ? "bg-red-500"
                          : "bg-black"
                      }`}
                    ></span>
                  </div>

                  {/* Open Button */}
                  <button
                    className="mt-3 w-full h-10 bg-transparent hover:bg-[#0e4749] text-black font-semibold text-md px-3 py-1 rounded border border-black hover:text-white transition"
                    onClick={() =>
                      history.push({
                        pathname: `/drawingdetailview/${packageName}/${file.filename}`,
                        state: { files },
                      })
                    }
                  >
                    Open
                  </button>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center text-center w-full h-full col-span-full">
                No Data Available
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PackageView;

